import { LIVE_SCENARIOS } from "@/lib/liveOps";

const NAME_BY_CASE = Object.fromEntries(LIVE_SCENARIOS.map((s) => [s.id, s.client.name]));

// Cases with a matching Outcome Attribution evidence row on /impact (single source for both directions)
export const IMPACT_CASES = ["ftd", "retention", "payments-esc", "kyc", "organic", "suppressed"];

export const CASE_BY_CLIENT = Object.fromEntries(IMPACT_CASES.map((id) => [NAME_BY_CASE[id], id]));

export const impactLinkForCase = (caseId) =>
  IMPACT_CASES.includes(caseId) ? `/impact?case=${caseId}&from=live` : null;

export const liveLinkForClient = (name) => {
  const id = CASE_BY_CLIENT[name];
  return id ? `/live?case=${id}&from=impact` : null;
};
